import { useQuery } from '@apollo/client';
import { GET_BOOKING_WALLET_LINK } from '../util/gql';

/**
 * The just-made booking's "Add to Google Wallet" link, or null: while
 * loading, when `enabled` is false (not the Aperio preset, staff booking),
 * and whenever the server has none to give (no plan on the booking, the
 * wallet not configured, or a server that does not know the query yet).
 */
export default function useBookingWalletLink(
  workOrderId: number | null | undefined,
  email: string | null | undefined,
  enabled: boolean,
): string | null {
  const { data } = useQuery(GET_BOOKING_WALLET_LINK, {
    variables: { workOrderId, email: email || null },
    skip: !enabled || !workOrderId,
    fetchPolicy: 'network-only',
  });
  const url = data?.bookingWalletLink?.googleSaveUrl;
  return typeof url === 'string' && /^https?:\/\//.test(url) ? url : null;
}
